module.exports = __webpack_public_path__ + "img/framework.6a708aaa.svg";